import axios from 'axios';
import Routes from './routing'
import reducer from './reducers'
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { configureStore } from '@reduxjs/toolkit';
import { PersistGate } from 'redux-persist/integration/react';
import { configureApi } from './api';
import 'react-responsive-modal/styles.css';



const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false})
});

export const api = configureApi(store);

const persistor = persistStore(store);

function App() {
  return (
    <PersistGate persistor={persistor}>
      <Provider store={store}>
        <Routes />
      </Provider>
    </PersistGate>
  );
}

export default App;
